import React, { ReactNode } from "react";

interface InputProps {
  id?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: () => void; // Add onFocus prop
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void; // Accepts the event
  type?: string;
  className?: string;
  placeholder?: string;
  onClear?: () => void;
  disabled?: boolean;
  icon?: ReactNode; // Optional icon on the left
  readOnly?: boolean;
  maxLength?: number;
}

const Input: React.FC<InputProps> = ({
  id,
  value,
  onChange,
  onKeyDown,
  onFocus, // Destructure onFocus
  onBlur, // Destructure onBlur
  type = "text",
  className = "",
  placeholder = "",
  onClear,
  disabled = false,
  icon, // Icon prop
  readOnly = false,
  maxLength,
}) => (
  <div className="relative flex items-center w-full">
    {icon && <div className="absolute left-2">{icon}</div>}{" "}
    {/* Display the icon */}
    <input
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus} // Pass onFocus to the input
      onBlur={onBlur} // Pass onBlur to the input
      placeholder={placeholder}
      maxLength={maxLength}
      className={`input-base ${icon ? "pl-10" : ""} ${className} ${
        disabled ? "cursor-not-allowed bg-gray-200" : ""
      }`} // Conditionally apply pl-10 if there's an icon
      disabled={disabled}
      readOnly={readOnly}
    />
    {value && onClear && !disabled && (
      <button
        type="button"
        onClick={onClear}
        className="absolute right-0 mr-2 text-gray-500 hover:text-gray-700"
      >
        &times;
      </button>
    )}
  </div>
);

export default Input;
